import BrandListView from './BrandListView';

export default BrandListView;
